import { BadgeCheck, BookOpen, Cake, Compass, FileDown, FileUp, GitFork, Heart, Lock, RefreshCw, Route, Search, UserPlus, Users } from 'lucide-react';
import { loadSampleTree } from '../../model/sample';
import { newTree } from '../../model/tree';
import { adoptTree, openDialog } from '../store';
import { startSync } from './SyncDialog';
import description from '../../../description.md?raw';

// Blank-line-separated paragraphs of description.md, shown as the welcome blurb.
const descriptionParagraphs = description
  .split(/\n\s*\n/)
  .map((p) => p.trim().replace(/\s+/g, ' '))
  .filter(Boolean);

export function Welcome() {
  return (
    <div className="welcome">
      <div className="welcome-inner">
        <div className="row" style={{ gap: 12 }}>
          <span className="brand-mark" style={{ width: 44, height: 44, borderRadius: 12 }}>
            <GitFork size={24} />
          </span>
          <h1>Relationships</h1>
        </div>
        <div className="lead">
          {descriptionParagraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
        <div className="welcome-actions">
          <button
            className="welcome-action"
            onClick={async () => {
              await adoptTree(newTree('My family'));
              openDialog({ type: 'new-person' });
            }}
          >
            <span className="t">
              <UserPlus size={18} /> Start a new tree
            </span>
            <span className="d">Begin with yourself or anyone you like.</span>
          </button>
          <button className="welcome-action" onClick={() => openDialog({ type: 'import', mode: 'new' })}>
            <span className="t">
              <FileUp size={18} /> Import a file
            </span>
            <span className="d">GEDCOM, MacFamilyTree, or a Relationships backup.</span>
          </button>
          <button className="welcome-action" onClick={async () => adoptTree(await loadSampleTree())}>
            <span className="t">
              <Compass size={18} /> Explore a sample
            </span>
            <span className="d">A multigenerational queer family to try things out on.</span>
          </button>
          <button className="welcome-action" onClick={startSync}>
            <span className="t">
              <RefreshCw size={18} /> Copy from another device
            </span>
            <span className="d">Sync the trees you have on your phone or another computer, over Wi-Fi.</span>
          </button>
        </div>
        <div className="feature-list">
          <div><Heart size={16} /> Partners of any gender, polyamorous relationships, any number of parents</div>
          <div><BadgeCheck size={16} /> Pronouns, chosen names, and self-described genders</div>
          <div><Users size={16} /> Found family, friend groups, households, mentors, and family friends</div>
          <div><Route size={16} /> “How are we related?” in plain words, like “half-sister’s spouse,” with the path between</div>
          <div><Search size={16} /> Search names, places, dates, and notes, forgiving typos and sound-alike surnames</div>
          <div><Cake size={16} /> Countdowns to birthdays, anniversaries, and more</div>
          <div><BookOpen size={16} /> Sources, photos, documents, and to-dos for your research</div>
          <div><FileDown size={16} /> Export to GEDCOM, PDF, PNG, SVG, CSV, or a web page</div>
          <div><Lock size={16} /> Private by design: no account, and your tree never goes through a server, even when you sync devices</div>
        </div>
      </div>
    </div>
  );
}
